// extracted by mini-css-extract-plugin
module.exports = {"emoji_btn":"styles_emoji_btn__3NvLc","emoji_box":"styles_emoji_box__3EKWc","show":"styles_show__YVwj7","emoji_item":"styles_emoji_item__qn1m3"};